// extracted by mini-css-extract-plugin
export default {"characterWrapper":"wordgame_characterWrapper__A02gw"};